<template>
  <div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Expenses" name="expenses">Current Service Under Development</el-tab-pane>
      <el-tab-pane label="Cheque Voucher (CV)" name="chequeVoucher">Current Service Under Development</el-tab-pane>
      <el-tab-pane label="Cash Disbursements" name="cashDisbursements">
        <cash-disbursements ref="cashDisbursements" :selectedRow="selectedRow"/>
      </el-tab-pane>
      <el-tab-pane label="Pre-payments" name="prePayments">
        <pre-payments ref="prePayments" :selectedRow="selectedRow"/>
      </el-tab-pane>
      <el-tab-pane label="Advances To" name="advancesTo">
        <advances-to ref="advancesTo" :selectedRow="selectedRow"/>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
  import AdvancesTo from '@/components/vendors/aT/AdvancesTo.vue'
  import PrePayments from '@/components/vendors/aT/PrePayments.vue'
  import CashDisbursements from '@/components/vendors/aT/CashDisbursements.vue'

  export default {
    props: ['selectedRow'],
    components: {
      AdvancesTo,
      PrePayments,
      CashDisbursements,
    },
    data() {
      return {
        activeName: 'expenses',
      }
    },
    methods: {
      handleClick(tab, event) {
        this.$refs[tab.name].openTab()
      },
      openTab() {
        this.activeName = 'expenses'
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>